// src/Home.js

import React,{ useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../Header';
import Footer from '../Footer';

import './styles.css';
import topoPneu from '../../assets/imagens/numeros-medidas-pneus.webp';
import { FaAndroid, FaRegFilePdf } from 'react-icons/fa';
function Downloads() {
  
  const [largura, setLargura] = useState(0);

  const [perfil, setPerfil] = useState(0);
  const [alturaPerfil, setAlturaPerfil] = useState(0);

  const [aro, setAro] = useState(0);

  const [diametro, setDiametro] = useState(0);

  const [circuferencia, setCircuferencia] = useState(0);
  function calcularCircuferencia(){
    setAlturaPerfil((largura*perfil)/100);
    var raio = (((aro*25.4)/2)+alturaPerfil);
    
    var circuferenciaPneus =2*3.1416*raio;
    console.log(alturaPerfil);
    console.log(raio);
    console.log(2*3.1416*raio);
    setDiametro(Math.round(raio*2));
    setCircuferencia(Math.round(circuferenciaPneus));
  }
  useEffect(() => {
    if (largura && perfil && aro) { // Evita calcular se algum valor estiver vazio
        const alturaPerfilAtual = (largura * perfil) / 100;
        
        setAlturaPerfil(alturaPerfilAtual);
        const raio = (((aro * 25.4) / 2) + alturaPerfilAtual);
        const circunferenciaPneus = 2 * Math.PI * raio;

        setDiametro(Math.round(raio * 2));
        setCircuferencia(Math.round(circunferenciaPneus));
    }
    else{
      setDiametro(0);
      setCircuferencia(0);
      setAlturaPerfil(0);
    }
}, [largura, perfil, aro]);
  const title = "Street Fighter - Downloads";
  const footerText = "© 2024 All rights reserved.";

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="Downloads painéis Street Fighter." />
      </Helmet>
      <Header title={title} />
      <main>
          <div className='tituloPagina'>
            <div>
              <a href='/'>Início</a> / Downloads
            </div>
            <div className='nomeTituloPagina'>
              Downloads
            </div>
          </div>
          <ul className='listaGabaritos'>
            <li>
              <a href="/download/160.pdf">
                <embed 
                  src="/download/160.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SF160
              </a>
            </li>
            <li>
              <a href="/download/CafeRacer.pdf">
                <embed 
                  src="/download/CafeRacer.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                Cafe Racer
              </a>
            </li>
            <li>
              <a href="/download/CBInferior.pdf">
                <embed 
                  src="/download/CBInferior.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                CB visão inferior
              </a>
            </li>
            <li>
              <a href="/download/CBSuperior.pdf">
                <embed 
                  src="/download/CBSuperior.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                CB visão superior
              </a>
            </li>
            <li>
              <a href="/download/SF1.pdf">
                <embed 
                  src="/download/SF1.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SF1
              </a>
            </li>
            <li>
              <a href="/download/SF2.pdf">
                <embed 
                  src="/download/SF2.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SF2
              </a>
            </li>
            <li>
              <a href="/download/SF3.pdf">
                <embed 
                  src="/download/SF3.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SF3
              </a>
            </li>
            <li>
              <a href="/download/SF110.pdf">
                <embed 
                  src="/download/SF110.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SF110
              </a>
            </li>
            <li>
              <a href="/download/SF125.pdf">
                <embed 
                  src="/download/SF125.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SF125
              </a>
            </li>
            <li>
              <a href="/download/SFBros.pdf">
                <embed 
                  src="/download/SFBros.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SFBros
              </a>
            </li>
            <li>
              <a href="/download/SFMini.pdf">
                <embed 
                  src="/download/SFMini.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SFMini
              </a>
            </li>
            <li>
              <a href="/download/SFZ.pdf">
                <embed 
                  src="/download/SFZ.pdf#toolbar=0&navpanes=0&scrollbar=0" 
                  type="application/pdf" 
                  width="100" 
                  height="130"
                />
                SFZ
              </a>
            </li>
            
            <li>
              <a href="/download/13.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v13
              </a>
            </li>
            <li>
              <a href="/download/12.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v12
              </a>
            </li>
            <li>
              <a href="/download/11.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v11
              </a>
            </li>
            <li>
              <a href="/download/10.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v10
              </a>
            </li>
            <li>
              <a href="/download/9.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v9
              </a>
            </li>
            <li>
              <a href="/download/8.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v8
              </a>
            </li>
            <li>
              <a href="/download/7.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v7
              </a>
            </li>
            <li>
              <a href="/download/6.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v6
              </a>
            </li>
            <li>
              <a href="/download/5.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v5
              </a>
            </li>
            <li>
              <a href="/download/4.apk">
                <FaAndroid className="icon" size={96}/>
                Aplicativo android v4
              </a>
            </li>
          </ul>

          <div className='calculadora-conversao'>
            
          <div className="titulo-rodas">
                  <h2>Calculadora de Circunferência</h2>
              </div>
          <div className="formulario">
        	
            
          <div className="medidas-topo">
            <img src={topoPneu} alt="Números do pneu"/>
          </div>
        
          <div className="medida-original">
            <div className="titulo-medida">
              <div colspan="4" className="tdTitulo">Medida do pneu</div>
            </div>
            <div className="opcvalores">
                <input  placeholder='Largura' onChange={(e) => setLargura(e.target.value)}/>
            </div>
            <div className="opcvalores">
                <input placeholder='Perfil' onChange={(e) => setPerfil(e.target.value)}/>
            </div>
            <div className="opcvalores">
                <input  placeholder='Aro' onChange={(e) => setAro(e.target.value)}/>
            </div>
          </div>
        

            </div>
            <div className="bloco-tamanho">
              <div className="bloco-img-original" >
                <div className="base-tamanho" >
                  <div className="pneu-original-diametro" >
                    <div className="texto-perfil texto-perfil-original">
                      Perfil: {alturaPerfil} mm
                      </div>
                    <div className="perfil-original" ></div>
                    <div className="texto-roda-original-diametro" >
                      <div>
                        Diâmetro: {diametro} mm
                      </div>
                      <div>
                      Circunferência: {circuferencia} mm
                      </div>
                    </div>
                    <div className="roda-original-diametro">

                    </div>
                  </div>
                </div>
                <div className="base-tamanho base-tamanho-largura" >
                  <div className="texto-largura texto-pneu-original-largura">
                    Largura: {largura} mm
                    </div>
                  <div className="pneu-original-largura tamanho-largura" >

                  </div>
                </div>
              </div>
          </div>
          {circuferencia ? (
              <h3>Sua Circunferência é {circuferencia} mm</h3>
            ) : (
              <h3></h3>
            )}
          </div>
      </main>
      <Footer footerText={footerText} />
    </div>
  );
}

export default Downloads;
